import { create } from "zustand";

export const useLtpStore = create((set, get) => ({

  ltps: {},

  // ---------------------------------------
  // Set Initial LTP data (if needed)
  // ---------------------------------------
  setInitialLtpData: (ltpMap) => {
    if (typeof ltpMap !== "object") return;
    set({ ltps: ltpMap });
  },

  // ---------------------------------------
  // UPDATE SINGLE LTP  (used by WebSocket)
  // ---------------------------------------
  updateLtp: (symbol, ltp) => {
    if (!symbol) return;

    set((state) => ({
      ltps: {
        ...state.ltps,
        [symbol]: ltp,
      },
    }));
  },

  // ---------------------------------------
  // GET LTP WITHOUT CAUSING RERENDER
  // ---------------------------------------
  getLtp: (symbol) => {
    return get().ltps[symbol] || null;
  },

}));
